






































	// @ts-ignore
    import _ from './CArticleFilter.ts'; export default _;
